export default function Loading() {
  return (
    <div className="max-w-[800px] sm:max-w-[400px] min-h-[600px] flex items-center justify-center">
      <div
        className="loader border-t-2 rounded-full border-gray-500 bg-gray-300 animate-spin
aspect-square w-8 flex justify-center items-center text-yellow-700"
      ></div>
    </div>
  );
}
